import { useQuery } from 'react-query';

import dealService from 'resources/deal/deal.service';

const getDealsByClientId = async (clientId) => {
  if (!clientId) {
    return null;
  }

  const deals = await dealService.getDealsByClientId(clientId);

  return deals;
};

export default function useDealsByClientId(clientId, queryOptions) {
  return useQuery(
    ['deal.getByClientId', clientId],
    () => getDealsByClientId(clientId),
    queryOptions,
  );
}
